// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sub-operators-list-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 0;
  margin: 0;
  border-radius: 5px;
}

.sub-operators-list-card-content {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 10px;
  gap: 5px;
}

.sub-operators-list-title-row {
  height: 10%;
}

.sub-operators-list-title-col {
  display: flex;
  flex-direction: column;
}

.title-text {
  color: black;
}

.actions-fab-col {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: right;
}

.fab ion-fab-button {
  width: 100%;
  height: 100%;
  margin: 0 !important;
}
.fab ion-icon {
  width: 50%;
  height: 50%;
}

.sub-operators-list-row {
  display: flex;
  flex-direction: row;
  gap: 5px;
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 5px;
}

.sub-operator-card {
  width: 100%;
  height: 60%;
  margin: 0;
  cursor: pointer;
  border: 2px solid transparent;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.sub-operator-card:hover {
  border-color: var(--ion-color-primary);
  box-shadow: var(--shadow-primary-sm);
}
.sub-operator-card ion-card-content {
  margin: 0;
  padding: 5px;
  height: 100%;
  width: 100%;
}

.sub-operator-card-title-row {
  width: 100%;
  height: 20%;
  padding: 0;
  margin: 0;
}

.sub-operator-fab-col {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: right;
}

.sub-operator-fab-list {
  display: flex;
  flex-direction: row;
  justify-content: right;
  gap: 5px;
}

.sub-operator-info-list-row {
  height: 80%;
  width: 100%;
}

.vehicleList {
  width: 100%;
  height: 100%;
}

/** Media queries to set font size and spacing based on screen size **/
/*#region Small Screens*/
/* Styles for screens smaller than 800px wide or 550 high */
@media (max-width: 599px) {
  .fab {
    width: 25px;
    height: 25px;
  }
}
/*#endregion Small Screens*/
/*#region Medium Screens*/
/* Styles for medium screens with min with of 800px and min height of 550px */
@media (min-width: 600px) and (max-width: 1023px) {
  .fab {
    width: 35px;
    height: 35px;
  }
}
/*#endregion Medium Screens*/
/*#region Larger Screens*/
/* Styles for screens larger than 1000px wide and 600px high */
@media (min-width: 1024px) {
  .fab {
    width: 45px;
    height: 45px;
  }
}
/*#endregion Larger Screens*/`, "",{"version":3,"sources":["webpack://./src/app/pages/fleet/components/sub-operators-list-card/sub-operators-list-card.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,QAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AACF;;AAIE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AADJ;AAIE;EACE,UAAA;EACA,WAAA;AAFJ;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EAEA,cAAA;EACA,gBAAA;EACA,YAAA;AAJF;;AAOA;EACE,WAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,6BAAA;EACA,8CAAA;AAJF;AAME;EACE,sCAAA;EACA,oCAAA;AAJJ;AAOE;EACE,SAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AALJ;;AASA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;AANF;;AASA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,QAAA;AANF;;AASA;EACE,WAAA;EACA,WAAA;AANF;;AASA;EACE,WAAA;EACA,YAAA;AANF;;AAUA,sEAAA;AAEE,wBAAA;AAEE,2DAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;EATN;AACF;AAYE,2BAAA;AAEA,yBAAA;AAEE,6EAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;EAZN;AACF;AAeE,4BAAA;AAEA,yBAAA;AAEE,8DAAA;AACA;EACE;IACE,WAAA;IACA,YAAA;EAfN;AACF;AAkBE,4BAAA","sourcesContent":[".sub-operators-list-card{\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 0;\r\n  margin: 0;\r\n  border-radius: 5px;\r\n}\r\n\r\n.sub-operators-list-card-content {\r\n  display: flex;\r\n  flex-direction: column;\r\n  width: 100%;\r\n  height: 100%;\r\n  padding: 10px;\r\n  gap: 5px;\r\n}\r\n\r\n.sub-operators-list-title-row {\r\n  height: 10%;\r\n}\r\n\r\n.sub-operators-list-title-col {\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.title-text {\r\n  color: black;\r\n}\r\n\r\n.actions-fab-col {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: right;\r\n}\r\n\r\n.fab {\r\n\r\n  ion-fab-button {\r\n    width: 100%;\r\n    height: 100%;\r\n    margin: 0 !important;\r\n  }\r\n\r\n  ion-icon {\r\n    width: 50%;\r\n    height: 50%;\r\n  }\r\n}\r\n\r\n.sub-operators-list-row {\r\n  display: flex;\r\n  flex-direction: row;\r\n  gap: 5px;\r\n\r\n  flex: 1 1 auto;\r\n  overflow-y: auto;\r\n  padding: 5px;\r\n}\r\n\r\n.sub-operator-card {\r\n  width: 100%;\r\n  height: 60%;\r\n  margin: 0;\r\n  cursor: pointer;\r\n  border: 2px solid transparent; // Add this line - initial transparent border\r\n  transition: border-color 0.2s, box-shadow 0.2s; // Add smooth transition\r\n\r\n  &:hover {\r\n    border-color: var(--ion-color-primary);\r\n    box-shadow: var(--shadow-primary-sm);\r\n  }\r\n\r\n  ion-card-content {\r\n    margin: 0;\r\n    padding: 5px;\r\n    height: 100%;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.sub-operator-card-title-row {\r\n  width: 100%;\r\n  height: 20%;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.sub-operator-fab-col {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: right;\r\n}\r\n\r\n.sub-operator-fab-list {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: right;\r\n  gap: 5px;\r\n}\r\n\r\n.sub-operator-info-list-row {\r\n  height: 80%;\r\n  width: 100%;\r\n}\r\n\r\n.vehicleList {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n\r\n/** Media queries to set font size and spacing based on screen size **/\r\n\r\n  /*#region Small Screens*/\r\n\r\n    /* Styles for screens smaller than 800px wide or 550 high */\r\n    @media (max-width: 599px) {\r\n      .fab {\r\n        width: 25px;\r\n        height: 25px;\r\n      }\r\n    }\r\n\r\n  /*#endregion Small Screens*/\r\n\r\n  /*#region Medium Screens*/\r\n\r\n    /* Styles for medium screens with min with of 800px and min height of 550px */\r\n    @media (min-width: 600px) and (max-width: 1023px) {\r\n      .fab {\r\n        width: 35px;\r\n        height: 35px;\r\n      }\r\n    }\r\n\r\n  /*#endregion Medium Screens*/\r\n\r\n  /*#region Larger Screens*/\r\n\r\n    /* Styles for screens larger than 1000px wide and 600px high */\r\n    @media (min-width: 1024px) {\r\n      .fab {\r\n        width: 45px;\r\n        height: 45px;\r\n      }\r\n    }\r\n\r\n  /*#endregion Larger Screens*/\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
